"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusEvent = void 0;
var inversify_1 = require("inversify");
var consts_1 = require("./consts");
var utils_1 = require("./utils");
var BusEvent = /** @class */ (function () {
    function BusEvent(utils) {
        this.utils = utils;
        this.eventMap = new Map();
    }
    /**
     * 监听唯一标记，运行回调函数（path为原始状态）
     * @param path 唯一标记
     * @param handler 回调函数
     */
    BusEvent.prototype.on = function (path, handler) {
        var _this = this;
        var handlers = this.eventMap.get(path);
        var cancel = function () {
            _this.off(path, handler);
        };
        if (handlers) {
            handlers.push(handler);
            return cancel;
        }
        this.eventMap.set(path, [handler]);
        window.addEventListener('message', handler.__handle = function (event) {
            var playload = event.data;
            if (playload.type !== consts_1.MESSAGE_KEY || path !== playload.path)
                return;
            var handlers = _this.eventMap.get(playload.path);
            if (!handlers || handlers.length === 0)
                return;
            for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
                var fn = handlers_1[_i];
                fn(playload.data, event);
            }
        });
        return cancel;
    };
    /**
     * 移除监听
     * @param path 唯一标记
     * @param handler 绑定函数
     */
    BusEvent.prototype.off = function (path, handler) {
        var handlers = this.eventMap.get(path);
        if (!handlers)
            return;
        var hs = handlers.filter(function (h) { return h === handler; }).map(function (h) {
            window.removeEventListener('message', h.__handle);
            return h;
        });
        hs.forEach(function (h) {
            var index = handlers.findIndex(function (h2) { return h2 === h; });
            handlers.splice(index, 1);
        });
    };
    BusEvent = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [utils_1.Utils])
    ], BusEvent);
    return BusEvent;
}());
exports.BusEvent = BusEvent;
//# sourceMappingURL=bus-event.js.map